import React from "react";
import notFoundImage from "../assets/images/notfound.png";

function NotFound() {
  return (
    <div
      className="min-h-screen bg-white flex flex-col items-center justify-center p-4 pt-0 mt-8"
      style={{ fontFamily: "Roboto, sans-serif" }}
    >
      {/* Custom 404 icon with animation */}
      <div className="w-72 sm:w-96 md:w-[400px] h-72 sm:h-96 md:h-[400px] animate-bounce-slow">
        <img
          src={notFoundImage}
          alt="Not Found"
          className="w-full h-full object-contain"
        />
      </div>

      {/* 404 Text */}
      <h1
        className="text-[80px] sm:text-[120px] font-bold leading-none -mt-12 sm:-mt-24"
        style={{ color: "#00AEEF" }}
      >
        404
      </h1>

      {/* Error message */}
      <p className="text-lg sm:text-xl mb-8" style={{ color: "#00AEEF" }}>
        Uh oh, something looks wrong here
      </p>

      {/* Back to home button */}
      <a
        href="/"
        className="text-xl sm:text-2xl transition-colors duration-200 flex items-center group text-black hover:text-[#00AEEF]"
      >
        back to home
        <span className="inline-block ml-2 transform translate-x-0 group-hover:translate-x-2 transition-transform duration-200">
          →
        </span>
      </a>
    </div>
  );
}

export default NotFound;
